/**
 * AutoCaptureRing
 *
 * Thin SVG progress ring that fills as the auto-capture countdown progresses.
 * Disappears (opacity 0) when progress = 0.
 */

import React from "react";

interface Props {
  /** 0–1 */
  progress: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
}

const AutoCaptureRing: React.FC<Props> = ({
  progress,
  size = 80,
  strokeWidth = 6,
  color = "#4ade80",
}) => {
  const r = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * r;
  const dashOffset = circumference * (1 - progress);

  return (
    <svg
      width={size}
      height={size}
      style={{
        position: "absolute",
        bottom: 28,
        left: "50%",
        transform: "translateX(-50%) rotate(-90deg)",
        opacity: progress > 0 ? 1 : 0,
        transition: "opacity 200ms",
        pointerEvents: "none",
        zIndex: 30,
      }}
    >
      {/* Track */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="rgba(255,255,255,0.15)"
        strokeWidth={strokeWidth}
      />
      {/* Fill */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 80ms linear" }}
      />
    </svg>
  );
};

export default AutoCaptureRing;
